// extracted by mini-css-extract-plugin
export var section = "comparison-module--section--2CqAJ";
export var heading = "comparison-module--heading--39ODv";
export var vs = "comparison-module--vs--3K596";
export var table = "comparison-module--table--ajr_o";
export var row = "comparison-module--row--c_gc9";
export var circle = "comparison-module--circle--1Q9tz";
export var check = "comparison-module--check--1eVAY";
export var copy = "comparison-module--copy--2FCm3";
export var footer = "comparison-module--footer--1fed8";